import { isEmpty } from 'lodash-es';

export function purchaseDotComAddonPayload({
  planId,
  subscriptionName,
  namespaceName,
  namespaceId,
  quantity,
  paymentMethodId,
  idempotencyKey,
  preview,
  addressDetails,
  companyDetails,
}) {
  const parameters = {
    subscription_id: subscriptionName,
    gl_namespace_name: namespaceName,
    gl_namespace_id: namespaceId,
    idempotency_key: idempotencyKey,
    preview,
    payment_method_id: paymentMethodId || '',
  };
  parameters.plan_id = planId;
  parameters.products = {
    main: {
      quantity,
    },
  };
  if (!isEmpty(addressDetails) && !isEmpty(companyDetails)) {
    parameters.customer = {
      address_1: addressDetails.address1,
      address_2: addressDetails.address2,
      country: addressDetails.country,
      state: addressDetails.state,
      city: addressDetails.city,
      zip_code: addressDetails.zipCode,
      company: companyDetails.companyName,
      // Should be refactored to using `tax`-names instead of `vat`:
      // https://gitlab.com/gitlab-org/customers-gitlab-com/-/issues/7469
      vat_code: companyDetails.taxId,
    };
  }

  return parameters;
}

export function receiptPayload({
  category,
  receiptType,
  taxCategory,
  title,
  companyNumber,
  companyBankName,
  companyBankNumber,
  companyAddress,
  companyPhone,
  receiveEmail,
  expressInfo,
  remark,
  invoiceIds,
}) {
  const isPerson = taxCategory === 'person';
  return {
    category,
    receipt_type: receiptType,
    tax_category: isPerson ? 'normal_tax' : taxCategory,
    title,
    invoice_ids: invoiceIds,
    company_number: companyNumber,
    company_bank_name: companyBankName,
    company_bank_number: companyBankNumber,
    company_address: companyAddress,
    company_phone: companyPhone,
    receive_email: receiveEmail,
    express_info: expressInfo,
    remark,
  };
}

export function changeSubscriptionNamespacePayload({
  planId,
  subscriptionName,
  quantity,
  orderId,
  namespaceName,
  namespaceId,
  preview,
  paymentMethodId,
  transaction,
}) {
  return {
    plan_id: planId,
    subscription_id: subscriptionName,
    subscription_name: subscriptionName,
    order_id: orderId,
    gl_namespace_id: namespaceId,
    gl_namespace_name: namespaceName,
    preview,
    payment_method_id: paymentMethodId || '',
    products: {
      main: {
        quantity,
      },
    },
    transaction,
  };
}

export function upgradeSubscriptionPayload({ planId, paymentMethodId }) {
  return {
    plan_id: planId,
    payment_method_id: paymentMethodId,
  };
}

export function changeNamespacePayload({
  seats,
  subscriptionName,
  selectedNamespaceId,
  selectedNamespaceName,
}) {
  return {
    products: {
      main: {
        quantity: seats,
      },
    },
    subscription_id: subscriptionName,
    subscription_name: subscriptionName,
    gl_namespace_id: selectedNamespaceId,
    gl_namespace_name: selectedNamespaceName,
  };
}

export function addSeatsPayload({
  products,
  isConfirmed,
  orderTotal,
  totalWithoutTaxes,
  subscriptionName,
  paymentMethodId,
  transaction,
}) {
  return {
    subscription_id: subscriptionName,
    products,
    order_total: orderTotal,
    total_without_taxes: totalWithoutTaxes,
    preview: !isConfirmed,
    source: isConfirmed ? 'upgrade' : 'preview',
    payment_method_id: paymentMethodId,
    transaction,
  };
}

export function purchaseDuoProPayload({
  products,
  isConfirmed,
  orderTotal,
  totalWithoutTaxes,
  subscriptionName,
  paymentMethodId,
  transaction,
  newProductId,
  newProductQuantity,
}) {
  return {
    subscription_id: subscriptionName,
    products,
    order_total: orderTotal,
    total_without_taxes: totalWithoutTaxes,
    preview: !isConfirmed,
    source: isConfirmed ? 'upgrade' : 'preview',
    payment_method_id: paymentMethodId,
    transaction,
    new_product_id: newProductId,
    new_product_quantity: newProductQuantity,
  };
}

export function newSubscriptionPayload({
  seats,
  planId,
  isConfirmed,
  orderTotal,
  totalWithoutTaxes,
  paymentMethodId,
  namespaceId,
  namespaceName,
  couponCode,
  promoCode,
  idempotencyKey,
  addressDetails,
  companyDetails,
}) {
  const payload = {
    plan_id: planId,
    products: {
      main: {
        quantity: seats,
      },
    },
    order_total: orderTotal,
    total_without_taxes: totalWithoutTaxes,
    preview: !isConfirmed,
    source: isConfirmed ? 'new' : 'preview',
    payment_method_id: paymentMethodId,
    gl_namespace_id: namespaceId,
    gl_namespace_name: namespaceName,
    coupon_code: couponCode,
    promo_code: promoCode,
    idempotency_key: idempotencyKey,
  };

  if (!isEmpty(addressDetails) && !isEmpty(companyDetails)) {
    payload.customer = {
      address_1: addressDetails.address1,
      address_2: addressDetails.address2,
      country: addressDetails.country,
      state: addressDetails.state,
      city: addressDetails.city,
      zip_code: addressDetails.zipCode,
      company: companyDetails.companyName,
      vat_code: companyDetails.taxId,
    };
  }
  return payload;
}
